import { defineComponent } from "vue";

export default defineComponent({
  props: {
    textElements: { type: Array, required: true },
    backgroundColor: { type: String, required: false },
    image: { type: String, required: false },
    imagePosition: { type: String, required: false },
  },
});
